import { Button, Form, Modal } from "antd";

import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
const { confirm } = Modal;

import {
  OPEN,
  FOR_APPROVAL,
  CANCELLED,
  ACCESS_CANCEL,
  ACCESS_APPROVE,
  ACCESS_PRINT,
  ACCESS_ADD,
  ACCESS_UPDATE,
  STATUS_FOR_VALIDATION,
} from "../utils/constants";
import { hasAccess } from "../utils/form_utilities";

import isEmpty from "../validation/is-empty";

export default function FormButtons({
  state,
  auth,
  loading,
  onClose,
  onDelete,
  onFinalize,
  additional_buttons = [],
  has_print = true,
  has_cancel = true,
  onSearch,
  has_save = true,
  save_statuses = [],
  onPrint,
  finalize_label,
  close_label = "CLOSE",
  loading_state = {},
}) {
  const location = useLocation();

  const disabled_buttons = (exempt_key) =>
    Object.values(loading_state).some(
      (val) => val === true && val !== loading_state?.[exempt_key]
    );

  return (
    <Form.Item className="m-t-1">
      <div className="field is-grouped">
        {[null, undefined, OPEN, ...save_statuses].includes(
          state.status?.approval_status
        ) &&
          isEmpty(state.deleted) &&
          has_save &&
          ((isEmpty(state._id) &&
            hasAccess({
              auth,
              access: ACCESS_ADD,
              location,
            })) ||
            (!isEmpty(state._id) &&
              hasAccess({
                auth,
                access: ACCESS_UPDATE,
                location,
              }))) && (
            <div className="control">
              <Button
                loading={loading_state?.save}
                htmlType="submit"
                className="button black-yellow"
                disabled={disabled_buttons("save")}
              >
                Save
              </Button>
            </div>
          )}
        {onFinalize &&
          !isEmpty(state._id) &&
          [null, undefined, OPEN, FOR_APPROVAL].includes(
            state.status?.approval_status
          ) &&
          isEmpty(state.deleted) && (
            <Button
              className="button is-info is-outlined  control"
              onClick={() => {
                onFinalize();
              }}
            >
              <span>{finalize_label}</span>
            </Button>
          )}
        {has_print &&
          state.status?.approval_status !== CANCELLED &&
          hasAccess({
            auth,
            access: ACCESS_PRINT,
            location,
          }) && (
            <div className="control">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  onPrint();
                }}
                className="button is-info is-outlined"
                disabled={disabled_buttons("print")}
              >
                <i className="fas fa-print pad-right-8" />
                Print
              </Button>
            </div>
          )}
        {!isEmpty(state?._id) &&
          additional_buttons.map((Component) => Component)}
        {onClose &&
          isEmpty(state.deleted) &&
          !isEmpty(state?._id) &&
          [OPEN, FOR_APPROVAL, STATUS_FOR_VALIDATION].includes(
            state.status?.approval_status
          ) &&
          hasAccess({
            auth,
            access: ACCESS_APPROVE,
            location,
          }) && (
            <div className="control">
              <Button
                loading={loading_state?.[close_label.toLowerCase()]}
                disabled={disabled_buttons(close_label.toLowerCase())}
                className="button is-info"
                onClick={(e) => {
                  e.preventDefault();
                  confirm({
                    title: "Close Transaction",
                    content: "Would you like to confirm?",
                    okText: "Close",
                    cancelText: "No",
                    onOk: () => {
                      onClose();
                    },
                    onCancel: () => {},
                  });
                }}
              >
                <i className="fas fa-lock pad-right-8" />
                {close_label}
              </Button>
            </div>
          )}
        {has_cancel &&
          isEmpty(state.deleted) &&
          ![CANCELLED].includes(state.status?.approval_status) &&
          !isEmpty(state?._id) &&
          hasAccess({
            auth,
            access: ACCESS_CANCEL,
            location,
          }) && (
            <div className="control">
              <Button
                disabled={disabled_buttons("cancel")}
                loading={loading_state?.cancel}
                className="button is-danger"
                onClick={(e) => {
                  e.preventDefault();
                  confirm({
                    title: "Cancel Transaction",
                    content: "Would you like to confirm?",
                    okText: "Cancel",
                    cancelText: "No",
                    onOk: () => {
                      onDelete();
                    },
                    onCancel: () => {},
                  });
                }}
              >
                <i className="fas fa-times pad-right-8" />
                Cancel
              </Button>
            </div>
          )}
        <div className="control">
          <Button
            className="button "
            onClick={(e) => {
              e.preventDefault();
              onSearch();
            }}
          >
            Exit
          </Button>
        </div>
      </div>
    </Form.Item>
  );
}
